<template>
  <v-container fluid>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12">
        <v-card outlined min-height="110vh">
          <v-row>
            <v-col cols="12">
              <v-sheet rounded="sm" width="160" max-width="160" class="pl-2">
                <v-list-item
                  class="py-0 px-0"
                  @click="$router.push('/manageCard')"
                >
                  <v-list-item-icon class="mr-0">
                    <v-icon small> mdi-chevron-left</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle>Your Card</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-sheet>
            </v-col>
          </v-row>

          <v-card-title>
            <div class="text-h5">Your Business Badge & QR Code Design</div>
          </v-card-title>
          <v-card-text>
            <v-tabs color="primary accent-4" v-model="tab">
              <v-tab
                class="text-capitalize"
                v-for="tabItem in tabItems"
                :key="tabItem.heading"
                >{{ tabItem.header }}</v-tab
              >
            </v-tabs>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="12">
                <v-tabs-items v-model="tab">
                  <v-tab-item eager>
                    <AddEditBadge />
                  </v-tab-item>
                  <v-tab-item eager>
                    <AddEditQRCode />
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AddEditBadge from "@/components/BadgeAndQRCode/AddEditBadge";
import AddEditQRCode from "@/components/BadgeAndQRCode/AddEditQRCode";

export default {
  components: {
    AddEditBadge,
    AddEditQRCode,
  },

  data() {
    return {
      tab: 0,
      isEditMode: false,
      tabItems: [
        { header: "Business Badge", content: "AddEditBadge" },
        {
          header: "QR Code",
          content: "",
        },
      ],
    };
  },
};
</script>

<style scoped>
.rounded-border-md {
  border-radius: 7px !important;
}

.v-list-item--link:hover {
  border-radius: 8px 8px 8px 8px !important;
}
.v-list-item--link:before {
  border-radius: 8px 8px 8px 8px !important;
}
</style>
